import { inject, Injectable, signal } from "@angular/core";
import { TopNavAbstraction } from "@app/shared-core/abstractions/top-nav.abstraction";
import { ELocalizationLang } from '@shared-core/enums/localization-lang.enum';
import { of } from 'rxjs';
import AuthUserModelInterface from '@kernel/shared/interfaces/auth-user-model.interface';
import { TranslationService } from "@kernel/translations/translation.service";

@Injectable({ providedIn: "root" })
export class TopNavService extends TopNavAbstraction {
  private translationService = inject(TranslationService);

  public authenticatedUser = signal({} as AuthUserModelInterface);

  changeMyPreferredLang(lang: ELocalizationLang) {
    this.translationService.saveUserLang(lang);
    return of(true);
  }
}
